import { Button } from "./Button";
import { usePagePermission } from "@/hooks/permission/usePagePermission";

type PermissionType = "canCreate" | "canUpdate" | "canDelete" | "canSave" | "canPrint" | "canExport";

interface PermissionButtonProps extends React.ComponentProps<typeof Button> {
  permission: PermissionType;
  children: React.ReactNode;
}

/**
 * 권한 체크가 자동으로 적용되는 Button 컴포넌트
 *
 * @example
 * ```tsx
 * <PermissionButton permission="canCreate" onClick={handleAdd}>
 *   추가
 * </PermissionButton>
 * ```
 */
export function PermissionButton({ permission, children, disabled, ...props }: PermissionButtonProps) {
  const pagePermission = usePagePermission();

  // 권한이 없거나 로딩 중이면 비활성화
  const isDisabled = !pagePermission[permission] || pagePermission.isLoading || disabled;

  return (
    <Button {...props} disabled={isDisabled}>
      {children}
    </Button>
  );
}
